<label class="d-flex align-items-center gap-2">
  <p-checkbox
    [formControl]="formControl | castTo: FormControl"
    [formlyAttributes]="field"
    [styleClass]="to?.styleClass"
    binary="true">
  </p-checkbox>
  @if (to?.labelValue) {
    <span>{{ to?.labelValue }}</span>
  }
</label>
